exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--Input__2erBM{width:200px;height:30px;color:#000;margin:0;border:1px solid #d3d9de;padding:5px 9px 7px;border-radius:2px;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;-webkit-box-shadow:none;box-shadow:none}.styles--FullWidth__3gLgM{-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;width:100%}.styles--search__3tyNU{background-color:transparent;width:100%;border:none;border-bottom:2px solid transparent}.styles--search__3tyNU::-webkit-input-placeholder{color:#b3c2da}.styles--search__3tyNU::-moz-placeholder{color:#b3c2da}.styles--search__3tyNU::-ms-input-placeholder{color:#b3c2da}.styles--search__3tyNU::placeholder{color:#b3c2da}.styles--search__3tyNU:focus{border-color:#b3c2da}\n", ""]);

// exports
exports.locals = {
	"Input": "styles--Input__2erBM",
	"input": "styles--Input__2erBM",
	"FullWidth": "styles--FullWidth__3gLgM",
	"fullWidth": "styles--FullWidth__3gLgM",
	"search": "styles--search__3tyNU"
};